import React from 'react';
import { BodyContentTextWSubheading } from '../../types';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { htmlSafe, wrapTableTags, removeEmptyPTags } from 'modules/utils/utils';
import { VideoWithCaption } from '../VideoWithCaption';

type TextWithSubheadingPropType = {
  multipleObjectParentModels: any;
};

export const TextWithSubheading: React.FunctionComponent<TextWithSubheadingPropType> =
  ({ multipleObjectParentModels }) => {
    const textWithSubheadingClass = clsx(
      styles.textWithSubheading,
      multipleObjectParentModels.enable_top_border && styles.topBorder,
      multipleObjectParentModels.enable_bottom_border && styles.bottomBorder,
    );

    const multipleObjectParentModel = multipleObjectParentModels.filter(
      (m: any) => m.tableWithTextImageModels.length > 0,
    )[0];

    const cardWithImageModels =
      multipleObjectParentModel?.tableWithTextImageModels;

    const multipleObjectParentModelTBC = multipleObjectParentModels.filter(
      (m: any) => m.tableOfContentModels.length > 0,
    )[0];

    const multipleObjectParentVideoGallaryModel =
      multipleObjectParentModels.filter(
        (m: any) => m.videoGalleryModels.length > 0,
      )[0];

    const cardWithVideoModels =
      multipleObjectParentVideoGallaryModel?.videoGalleryModels;

    return (
      <div className={textWithSubheadingClass}>
        {cardWithImageModels &&
          cardWithImageModels.length > 0 &&
          cardWithImageModels.map((card: any, index: number) => (
            <div
              key={
                cardWithImageModels[0].title === ' ' ? index : index + 1 + ''
              }
            >
              {card.title === ' ' && (
                <h3 className={styles.title}>
                  <span
                    id={
                      cardWithImageModels[0].title === ' '
                        ? index + ''
                        : index + 1 + ''
                    }
                  >
                    {card.title + ''}
                  </span>
                </h3>
              )}
              {card.title !== ' ' && multipleObjectParentModelTBC && (
                <span className={styles['contents-heading']}>
                  <h2
                    className={styles.title}
                    id={
                      cardWithImageModels[0].title === ' '
                        ? index + ''
                        : index + 1 + ''
                    }
                  >
                    <span>
                      {' '}
                      {cardWithImageModels[0].title === ' '
                        ? index
                        : index + 1 + ''}
                      .&nbsp;{htmlSafe(card.title)}
                    </span>
                  </h2>
                </span>
              )}
              {card.title !== ' ' && !multipleObjectParentModelTBC && (
                <span className={styles['contents-heading']}>
                  <h3 className={styles.title}>
                    <span id={index + 1 + ''}>{card.title}</span>
                  </h3>
                </span>
              )}
              {card.tableWithTextImages.map(
                (tableWithTextImage: any, index: number) => (
                  <div key={index + 1}>
                    {(tableWithTextImage.type === 'Paragraph' ||
                      tableWithTextImage.type === 'Table') &&
                      htmlSafe(
                        wrapTableTags(
                          removeEmptyPTags(tableWithTextImage.typeValue),
                        ),
                      )}
                    {tableWithTextImage.type === 'Image' && (
                      <img
                        src={tableWithTextImage.typeValue}
                        alt={`card-${index + 1}`}
                        style={{ marginTop: '15px', marginBottom: '15px' }}
                      />
                    )}
                  </div>
                ),
              )}
            </div>
          ))}

        {cardWithVideoModels &&
          cardWithVideoModels.length > 0 &&
          cardWithVideoModels.map((card: any, index: number) => (
            <div key={index + 1}>
              {card.title && (
                <h3 className={styles.title}>
                  <span id={index + 1 + ''}>{card.title}</span>
                </h3>
              )}
              {card.description &&
                htmlSafe(wrapTableTags(removeEmptyPTags(card.description)))}
              <VideoWithCaption
                key={++index}
                videoUploadModels={[cardWithVideoModels[index]]}
              />
            </div>
          ))}
      </div>
    );
  };
